import Icon, { SettingOutlined, ShoppingCartOutlined, UserOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { ReactComponent as dashboardIcon } from '../assets/icons/ic_dashboard.svg';
import { ReactComponent as storeIcon } from '../assets/icons/ic_store.svg';
import { ReactComponent as analyticsIcon } from '../assets/icons/ic_analytics.svg';
import { ReactComponent as promotionIcon } from '../assets/icons/ic_promotion.svg';
import { ReactComponent as ingredientIcon } from '../assets/icons/ic_ingredient.svg';
import { ReactComponent as bestdealIcon } from '../assets/icons/ic_bestdeal.svg';
import { ReactComponent as productIcon } from '../assets/icons/ic_product.svg';
import { ReactComponent as postIcon } from '../assets/icons/ic_post.svg';
import { ReactComponent as categoryIcon } from '../assets/icons/ic_category.svg';
import { ReactComponent as locationIcon } from '../assets/icons/ic_location.svg';
import { ReactComponent as unitIcon } from '../assets/icons/ic_unit.svg';

export const ROOT = "/";
export const ROUTE_DASHBOARD = "/dashboard";
export const ROUTE_IMAGE_LIST = "/images";
export const ROUTE_VIDEO_LIST = "/videos";
export const ROUTE_RECIPE_LIST = "/recipes";
export const ROUTE_SHOP_PRODUCT_LIST = "/shop/products";
export const ROUTE_SHOP_CATEGORY_LIST = "/shop/categories";
export const ROUTE_SHOP_ORDER_LIST = "/shop/orders";
export const ROUTE_USERS = "/users";
export const ROUTE_LOGIN = "/login";
export const ROUTE_PROFILE = "/profile";
export const ROUTE_SETTINGS = "/settings";



export const MENU_ITEMS = [
    { route: ROUTE_DASHBOARD, icon: <Icon component={dashboardIcon} className="menu-item-icon" />, title: "Dashboard", type:"sidebar" },
    { route: ROUTE_IMAGE_LIST, icon: <Icon component={storeIcon} className="menu-item-icon" />, title: "Images", type:"sidebar"},
    { route: ROUTE_VIDEO_LIST, icon: <Icon component={promotionIcon} className="menu-item-icon" />, title: "Videos", type:"sidebar"},
    { route: ROUTE_RECIPE_LIST, icon: <Icon component={ingredientIcon} className="menu-item-icon" />, title: "Recipe", type:"sidebar"},
    { route: "/shop", icon: <ShoppingCartOutlined className="menu-item-icon" />, title: "Shopping", type:"sidebar", submenu: [
        { route: ROUTE_SHOP_PRODUCT_LIST, icon: <Icon component={productIcon} className="menu-item-icon" />, title: "Products", type:"sidebar"},
        { route: ROUTE_SHOP_CATEGORY_LIST, icon: <Icon component={categoryIcon} className="menu-item-icon" />, title: "Categories", type:"sidebar"},
        { route: ROUTE_SHOP_ORDER_LIST, icon: <Icon component={bestdealIcon} className="menu-item-icon" />, title: "Orders", type:"sidebar"},
    ]},
    { route: ROUTE_PROFILE, icon: <Icon component={analyticsIcon} className="menu-item-icon" />, title: "Profile", type:"sidebar"},
    { route: ROUTE_SETTINGS, icon: <SettingOutlined className="menu-item-icon" />, title: "Settings", type:"sidebar"},
]

export const SUPER_ITEM = [
    { route: ROUTE_USERS, icon: <Icon component={productIcon} className="menu-item-icon" />, title: "Users", type:"sidebar"},
]
